export const formatTimeLabel = (timeValue) => {
  if (!timeValue) return "";
  if (typeof timeValue === "string") {
    const [hourStr, minuteStr] = timeValue.split(":");
    const hour = Number(hourStr);
    const minute = Number(minuteStr);
    if (Number.isNaN(hour) || Number.isNaN(minute)) return "";
    const suffix = hour >= 12 ? "PM" : "AM";
    const hour12 = hour % 12 || 12;
    return `${hour12}:${minuteStr} ${suffix}`;
  }
  if (timeValue.toDate) {
    const date = timeValue.toDate();
    return date.toLocaleTimeString([], { hour: "numeric", minute: "2-digit" });
  }
  const date = new Date(timeValue);
  if (Number.isNaN(date.getTime())) return "";
  return date.toLocaleTimeString([], { hour: "numeric", minute: "2-digit" });
};

export const getLocalDateStr = (date = new Date()) =>
  new Date(date.getTime() - date.getTimezoneOffset() * 60000)
    .toISOString()
    .slice(0, 10);

export const isWithinPowerHour = (start, end, now = new Date()) => {
  if (!start || !end || typeof start !== "string" || typeof end !== "string") return false;
  const [startH, startM] = start.split(":").map(Number);
  const [endH, endM] = end.split(":").map(Number);
  if ([startH, startM, endH, endM].some(Number.isNaN)) return false;
  const startDate = new Date(now);
  startDate.setHours(startH, startM, 0, 0);
  const endDate = new Date(now);
  endDate.setHours(endH, endM, 0, 0);
  if (endDate <= startDate) {
    // Overnight window (e.g., 22:00 - 01:00)
    return now >= startDate || now <= endDate;
  }
  return now >= startDate && now <= endDate;
};

export const getTaskDueDate = (task, now = new Date()) => {
  if (!task) return null;
  if (task.dueAt?.toDate) return task.dueAt.toDate();
  if (task.dueAt) {
    const due = new Date(task.dueAt);
    if (!Number.isNaN(due.getTime())) return due;
  }
  if (task.expirationTime?.toDate) return task.expirationTime.toDate();
  if (task.expiryTime || task.expirationTime) {
    const timeStr = task.expiryTime || task.expirationTime;
    if (typeof timeStr === "string" && timeStr.includes(":")) {
      const [hourStr, minuteStr] = timeStr.split(":");
      const hour = Number(hourStr);
      const minute = Number(minuteStr);
      if (Number.isNaN(hour) || Number.isNaN(minute)) return null;
      const due = new Date(now);
      due.setHours(hour, minute, 0, 0);
      return due;
    }
  }
  return null;
};

export const getTaskGraceMs = (task, familyGraceMinutes) => {
  const minutes = Number(familyGraceMinutes ?? 0);
  if (!Number.isFinite(minutes) || minutes <= 0) return 0;
  return minutes * 60 * 1000;
};

export const isTaskDueSoon = (task, windowMinutes = 120, now = new Date()) => {
  const due = getTaskDueDate(task, now);
  if (!due) return false;
  const diffMs = due.getTime() - now.getTime();
  return diffMs >= 0 && diffMs <= windowMinutes * 60 * 1000;
};

export const isTaskOverdue = (task, now = new Date(), familyGraceMinutes) => {
  const due = getTaskDueDate(task, now);
  if (!due) return false;
  const graceMs = getTaskGraceMs(task, familyGraceMinutes);
  return due.getTime() + graceMs < now.getTime();
};
